import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const InfoFilledGlyph = /*#__PURE__*/createElement("g", {
  id: "info_filled"
}, /*#__PURE__*/createElement("path", {
  d: "M42,15c-14.9,0-27,12.1-27,27s12.1,27,27,27s27-12.1,27-27S56.9,15,42,15z M40.1,30.8 c0.5-0.5,1.1-0.7,1.8-0.7c0.7,0,1.3,0.2,1.8,0.7s0.7,1.1,0.7,1.8c0,0.7-0.2,1.4-0.7,1.8c-0.5,0.5-1,0.7-1.7,0.7s-1.2-0.2-1.8-0.7 c-0.5-0.4-0.8-1-0.8-1.8C39.4,31.9,39.6,31.3,40.1,30.8z M44,54h-4c-1.1,0-2-0.9-2-2s0.9-2,2-2v-9c-1.1,0-2-0.9-2-2s0.9-2,2-2h2 c1.1,0,2,0.9,2,2v11c1.1,0,2,0.9,2,2S45.1,54,44,54z"
}));
const InfoFilled = createSvg({
  name: 'info_filled',
  path: InfoFilledGlyph
});

export default InfoFilled;
export { InfoFilledGlyph };
